import { isNativeApp } from '@lemonade-hq/uniclient-mobile-bridge';
import { useEffect } from 'react';
import { IS_NATIVE_ATTRIBUTE } from './useBodyNativeIndication.css';

export const useBodyNativeIndication = (): void => {
  useEffect(() => {
    if (!isNativeApp()) return;

    document.body.setAttribute(IS_NATIVE_ATTRIBUTE, '');
  }, []);
};
